<template>
    <CustomHeader :text="$t('common.sake')" />
    <div class="withdraw_container">
        <div class="top-banner">
            <img src="@/assets/withdraw/withdraw_bg.png" alt="" >
        </div>
        <div class="channel_text">{{ $t('common.paymentChannel') }}：</div>
        <div class="channel_list">
            <div class="channel_card" v-for="item in dataSet?.channelList" :key="item.name"
                :class="dataSet?.activeChannel.id == item.id ? 'active_channel' : ''" @click="selectChannel(item)">
                {{ item.name }}
            </div>
        </div>
        <div class="line"></div>
        <div class="balance_container">
            <div class="balance_text">{{ $t('withdraw.myBalance') }}:</div>
            <div class="balance_value">{{ formatCurrency(dataSet?.balanceAmount) }}</div>
        </div>
        <div class="sub_container">
            <div class="input_text">{{ $t('withdraw.withdrawalAmount') }}</div>
            <InputField :modelValue="dataSet?.selectedAmount" :labelText="$t('withdraw.valueLabel')"
                @valueChanged="inputValueChange" />
        </div>
        <div class="btn_container">
            <MainButton :title="$t('common.sake')" :activeStatus="dataSet?.activeButton" @click="confirmWithdraw" />
        </div>
    </div>
    <!-- <WithdrawPopup ref="withdrawConfirmRef" /> -->
   
</template>

<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import { ref, defineEmits, defineProps, defineExpose } from 'vue'
import InputField from '../withdraw/components/inputField.vue';
import { PayChannel } from '@/types/common';
import WithdrawPopup from '../../themeOne/withdraw/withdrawPopup.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { WithdrawViewData } from '@/view/withdraw/supportScript';
import MainButton from '../components/common/mainButton.vue';

const emits = defineEmits(['confirmWithdraw','selectChannel','inputValueChange'])


const props = defineProps<{
    dataSet: WithdrawViewData
}>()

const selectChannel = (item: PayChannel) => {
    emits('selectChannel',item)
}

const inputValueChange = (value: any) => { 
    emits('inputValueChange',value)
}

const confirmWithdraw = () => {
    emits('confirmWithdraw')
}
</script>
<style scoped>
.withdraw_container {
    padding: 70px 0;
}

.channel_text {
    color: #ffffffd9;
    font-size: 14px;
    padding-top: 15px;
    padding-left: 25px;
}

.channel_list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 25px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 5px;
    width: 70px;
    color: #ffffff;
    background-color: #ffffff26;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 10px 30px;
    margin-right: 10px;
    font-size: 14px;
}

.active_channel {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
}

.line {
    margin-top: 5px;
    height: 0.5px;
    width: 100%;
    background: rgba(255, 255, 255, 0.25);
    ;
}

.btn_container {
    padding: 30px 90px;
}

.balance_container {
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 3vh;
}

.balance_text {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.65);
}

.balance_value {
    color: rgba(255, 255, 255, 0.85);
    font-size: 45px;
}

.sub_container {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    padding: 0 25px;
}

.sub_container ::v-deep .van-field {
    border-radius: 10px;
    padding: 2vh !important
}

 .btn_container ::v-deep .defaultButton .van-button--default  {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.top-banner {
    padding: 5px 15px;
}

.top-banner img {
    width: 100%;
    border-radius: 20px;
}

@media (min-width: 1440px) {
    .channel_text {
        font-size: 3vh;
    }
    .channel_card, 
    .balance_text, 
    .sub_container, 
    .sub_container ::v-deep .van-field, 
    .btn_container ::v-deep .defaultButton .van-button--default  {
        font-size: 2vh;
    }
    .active_channel {
        padding: 15px 3vh !important;
    }
}

@media (min-width: 1920px) {
    .channel_text {
        font-size: 3vh;
    }
    .channel_card, 
    .balance_text, 
    .sub_container, 
    .sub_container ::v-deep .van-field, 
    .btn_container ::v-deep .defaultButton .van-button--default  {
        font-size: 2vh;
    }
    .active_channel {
        padding: 15px 3vh !important;
    }
}
</style>